import { FiAward, FiHeart, FiTarget, FiUsers } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const Introduction = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FiUsers,
      title: t("about.features.community.title"),
      description: t("about.features.community.description"),
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600",
    },
    {
      icon: FiHeart,
      title: t("about.features.humanitarian.title"),
      description: t("about.features.humanitarian.description"),
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      iconColor: "text-red-600",
    },
    {
      icon: FiTarget,
      title: t("about.features.sustainable.title"),
      description: t("about.features.sustainable.description"),
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      iconColor: "text-green-600",
    },
    {
      icon: FiAward,
      title: t("about.features.registered.title"),
      description: t("about.features.registered.description"),
      color: "from-yellow-500 to-yellow-600",
      bgColor: "bg-yellow-50",
      iconColor: "text-yellow-600",
    },
  ];

  return (
    <section
      id="about-us"
      className="overflow-x-hidden px-4 py-20 md:px-8 lg:px-16 bg-gradient-to-br from-green-50 via-white to-green-50"
    >
      <div className="mx-auto max-w-7xl">
        {/* Header */}
        <div className="mb-16 text-center">
          <h2 className="mb-6 text-4xl md:text-5xl lg:text-6xl font-bold text-green-800">
            {t("about.title")}
          </h2>
          <div className="mx-auto h-1 w-24 bg-green-600"></div>
        </div>

        {/* Main Content */}
        <div className="mb-20 grid items-center gap-12 lg:grid-cols-2">
          {/* Text Content */}
          <div className="space-y-6 order-2 lg:order-1">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="space-y-6">
                <p className="text-lg leading-relaxed text-gray-700">
                  {t("about.description1")}
                </p>
                <p className="text-lg leading-relaxed text-gray-700">
                  {t("about.description2")}
                </p>
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-lg leading-relaxed text-gray-700">
                    {t("about.mottoLabel")}{" "}
                    <strong className="text-green-800 text-xl">
                      "{t("about.motto")}"
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative order-1 lg:order-2">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="/images/image_1.jpg"
                alt="ACDHA Team"
                className="h-96 w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-green-800/70 via-green-800/30 to-transparent"></div>
            </div>
            <div className="absolute -bottom-6 -right-6 rounded-xl bg-gradient-to-r from-green-600 to-green-700 p-6 text-white shadow-xl border-4 border-white">
              <div className="text-3xl font-bold mb-1">2021</div>
              <div className="text-sm font-medium opacity-90">
                {t("about.founded")}
              </div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-md hover:shadow-xl transition-all duration-300 hover:border-green-300"
            >
              <div
                className={`mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-r ${feature.color} shadow-lg`}
              >
                <feature.icon className="h-10 w-10 text-white" />
              </div>
              <h3 className="mb-3 text-xl font-bold text-gray-800 group-hover:text-green-700 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm leading-relaxed text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Introduction;
